import React, { Component } from "react";
import * as Icons from "../../constants/SvgIcons";
export default class Icon extends Component {
    render() {
        const { icon, viewbox } = this._renderGraphic();
        return (<span className={`icon icon_${this.props.icon}`}>
				<svg viewBox={viewbox} preserveAspectRatio="xMidYMid meet" className={`icon-inner icon-inner_${this.props.icon}`} aria-hidden="true" focusable="false">
					{icon}
				</svg>
			</span>);
    }
    _renderGraphic() {
        const viewbox = "0 0 100 100";
        switch (this.props.icon) {
            case "close":
                return {
                    viewbox,
                    icon: Icons.ICONS.CLOSE
                };
            case "event":
                return {
                    viewbox: "0 0 100 111.1",
                    icon: Icons.ICONS.EVENT
                };
            case "edit":
                return {
                    viewbox,
                    icon: Icons.ICONS.EDIT
                };
            case "home":
                return {
                    viewbox: "0 0 24 24",
                    icon: Icons.ICONS.HOME
                };
            case "profile":
                return {
                    viewbox: "0 0 24 24",
                    icon: Icons.ICONS.PROFILE
                };
            case "phone":
                return {
                    viewbox: "0 0 24 24",
                    icon: Icons.ICONS.PHONE
                };
            case "emailOptOut":
                return {
                    viewbox: "-3 -3 31 31",
                    icon: Icons.ICONS.EMAIL_OPT_OUT
                };
            case "logout":
                return {
                    viewbox,
                    icon: Icons.ICONS.LOGOUT
                };
            case "arrowRight":
                return {
                    viewbox: "0 0 24 24",
                    icon: Icons.ICONS.ARROW_RIGHT
                };
            case "arrowLeft":
                return {
                    viewbox: "0 0 24 24",
                    icon: Icons.ICONS.ARROW_LEFT
                };
            case "loading":
                return {
                    viewbox: "0 0 24 24",
                    icon: Icons.ICONS.LOADING
                };
            case "court":
                return {
                    viewbox: "105 92 302 302",
                    icon: Icons.ICONS.COURT
                };
            case "document":
                return {
                    viewbox: "-63 -81 504 648",
                    icon: Icons.ICONS.DOCUMENTS
                };
            case "chat":
                return {
                    viewbox: "0 0 1792 1792",
                    icon: Icons.ICONS.CHAT
                };
            case "email":
                return {
                    viewbox: "0 0 240 240",
                    icon: Icons.ICONS.EMAIL
                };
            case "register":
                return {
                    viewbox: "0 0 24 24",
                    icon: Icons.ICONS.REGISTER
                };
            case "quickpay":
                return {
                    viewbox: "0 0 24 24",
                    icon: Icons.ICONS.QUICKPAY
                };
            default:
                /* Close icon is the default */
                return {
                    viewbox,
                    icon: Icons.ICONS.CLOSE
                };
        }
    }
}
Icon.defaultProps = {
    icon: "close"
};



// WEBPACK FOOTER //
// ./src/assets/scripts/components/presentational/Icon.tsx